const moduleName = "whitelabel";

const state = {
  isLoadMore: false,
  isFilter: false,
  response: {},
  whitelabel: [],
  detailPesanan: {},

  dataOwner: [],

  detailPembayaran: [],

  dataPembayaran: [],
};

export { state as default, moduleName };
